<template>
  <el-form
    ref="formRef"
    require-asterisk-position="right"
    label-position="top"
    :model="form"
  >
    <div class="info-card-title">
      合同自定义字段
      <el-link type="primary" :underline="false" @click="viewInstructions">
        查看说明
      </el-link>
    </div>
    <div v-if="data.customFieldList" class="flex">
      <div class="oa-form-left">
        <div v-for="(fieldItem,index) in data.customFieldList" :key="fieldItem.fieldCode">
          <el-form-item
            v-if="index%2==0"
            :label="fieldItem.field"
            :rules="{
              required: fieldItem.requiredField==1, message: fieldItem.field+'不能为空', trigger: 'blur'
            }"
          >
            <el-input
              v-model="form.contractCustomFieldList[index].fieldValue"
              clearable
              autocomplete="nony"
              placeholder="请输入"
            />
          </el-form-item>
        </div>
      </div>
      <div class="oa-form-right">
        <div v-for="(fieldItem,index) in data.customFieldList" :key="fieldItem.fieldCode">
          <el-form-item
            v-if="index%2==1"
            :label="fieldItem.field"
            :rules="{
              required: fieldItem.requiredField==1, message: fieldItem.field+'不能为空', trigger: 'blur'
            }"
          >
            <el-input
              v-model="form.contractCustomFieldList[index].fieldValue"
              clearable
              autocomplete="nony"
              placeholder="请输入"
            />
          </el-form-item>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script setup lang="ts">
import { h, PropType, ref, watch } from 'vue';
import { queryContractTempPlatformInfo } from '../../../../..';
import { ElMessage } from 'element-plus';
import { EActorType } from '../../../../../types/contracts/contracts';
import { onConfirm } from '@vue3/components';
import img from '../../../../../assets/images/empty.png';
import { IContractFreeDetailVO } from '../../../../../types/contracts/contracts';
import { isNull } from '@core/tools';

const props = defineProps({
  data: {
    type: Object as PropType<IContractFreeDetailVO>,
    default: () => {
      return {} as IContractFreeDetailVO;
    },
  },
  enableEnterKey: {
    type: Boolean,
    default: true,
  },
  /** 自动滚动到错误位置 */
  autoScrollToError: {
    type: Boolean,
    default: true,
  },
});

const form = ref({ contractCustomFieldList: props.data.customFieldList });
const platformList = ref([]);
const formRef = ref();

function viewInstructions() {
  onConfirm({
    message: h('div', null, [
      h('div', { }, '这里需要填写的合同自定义字段为在创建合同模版时，未设置参与方的字段，如果现在填写要求为必填，那么这边也必须填写后才能发起合同。'),
      h('img', {
        class: 'popconfirm-img',
        style: 'margin: 0 auto;',
        src: img,
      }),
    ]),
    showCancelButton: false,
    okText: '确定',
  });

}

async function queryplatformOption() {
  try {
    platformList.value = await queryContractTempPlatformInfo({
      actorType: EActorType.CORP,
      chooseSass: 0,
    });

  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

queryplatformOption();

function initForm() {
  form.value = { contractCustomFieldList: props.data.customFieldList };
}

watch(
  () => props.data,
  () => {
    if (!isNull(props.data)) {
      initForm();
    }
  },
);

async function validate(callback?: () => void) {
  let valid = false;

  if (!formRef.value) return valid;

  await formRef.value.validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    }
  });

  return valid;
}

function resetFormValues() {

  formRef.value?.resetFields?.();
}

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => form.value,
  /** 表单数据重置（base props.data） */
  reset: resetFormValues,
});

</script>

<style lang="scss" scoped>
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1010px;
  height: 48px;
  background: #F5F6FA;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #EBEEF5;
  line-height: 48px;
  padding-left: 16px;
  padding-right: 16px;
  font-weight: 500;
  font-size: 14px;
  color: #262626;
  margin-bottom: 24px;
}
.title-button{
  color: #1777FF;
}
.oa-form-left {
  width: 432px;
}

.oa-form-right {
  width: 432px;
  margin-left: 114px;
}

.label {
  position: relative;

  & .tip {
    position: absolute;
    top: -30px;
    left: 85px;

  }
}

</style>
